// Function to get unique values from a column in the raw data
const getUniqueValues = (rawData, columnField) => {


  return Array.from(new Set(rawData.map((item) => item[columnField])));
};

const castToNumberData = (rawData, valueKeyArray) => {
  console.log(valueKeyArray);

  if (!rawData) return null;
  if (!valueKeyArray || (Array.isArray(valueKeyArray) && valueKeyArray.length) === 0) {
    return rawData
  }

  const numberData = rawData.map((row) => {
    // Create a shallow copy of the row
    const updatedRow = { ...row };

    // Cast each specified key to a number
    valueKeyArray.forEach((key) => {
      if (updatedRow.hasOwnProperty(key)) {
        updatedRow[key] = Number(updatedRow[key]);
      }
    });

    return updatedRow;
  });

  console.log(numberData);
  return numberData; // Return the transformed data if needed
};

// Function to transform data for a stacked bar chart
const transformData = (
  rawData,
  rawGroupbyKeys,
  rawRowKey,
  valueObjectArray
) => {
  console.log(rawData);

  if (!rawData) return null;
  // Extract the keys we need to sum up
  const valueKeyArray = valueObjectArray.map((item) => item.responseKey);
  const rowKey = rawRowKey.map((item) => item.responseKey);
  const columnKey = rawGroupbyKeys.map((item) => item.responseKey);
  console.log(columnKey);

  console.log(rowKey);



  // Step 1: Get unique column values
  const uniqueColumnValues = rowKey.length > 0 ? getUniqueValues(rawData, rowKey) : null;
  console.log(uniqueColumnValues);


  //numberify the data

  const data = castToNumberData(rawData, valueKeyArray)


  // // Step 2: Get unique row values
  // const uniqueRowValues = getUniqueValues(rawData, rowKey);

  // // Step 3: Create a raw table with 0s
  // const table = uniqueRowValues.map((rowValue) => {
  //   const rowObject = { [rowKey]: rowValue };
  //   uniqueColumnValues.forEach((columnValue) => {
  //     rowObject[columnValue] = 0;
  //   });
  //   return rowObject;
  // });

  // // Step 4: Calculate and put the sum in each cell
  // rawData.forEach((item) => {
  //   const rowObject = table.find((row) => row[rowKey] === item[rowKey]);
  //   valueKeyArray.forEach((valueKey) => {
  //     rowObject[item[columnKey]] += item[valueKey];
  //   });
  // });
  // // console.log(table);

  return { data, uniqueColumnValues };
};

export { transformData, getUniqueValues, castToNumberData };
